import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Delete an entity by entityPrimaryId.
 * DELETE api/Onboarding/delete-entity/{entityPrimaryId}
 */
export const deleteEntityAction = async (entityPrimaryId) => {
  try {
    const response = await apiClient.delete(
      `${ATP_API_URL.DELETE_ENTITY}/${entityPrimaryId}`,
    );

    if (response?.status === 200) {
      if (response.data?.success === false) {
        return {
          success: false,
          message: response.data.message || "Failed to delete entity",
        };
      }
      return {
        success: true,
        message: response.data?.message || "Entity deleted successfully",
      };
    }

    return { success: false, message: "Failed to delete entity" };
  } catch (error) {
    return {
      success: false,
      message: error.message || "Failed to delete entity",
    };
  }
};
